
import char_1 from '@/assets/f_c_sc_1.png'
import char_2 from '@/assets/f_c_sc_2.png'
import char_3 from '@/assets/f_c_sc_3.png'
import char_4 from '@/assets/f_c_sc_4.png'
import char_5 from '@/assets/f_c_sc_5.png'

import Router from '@/router/index'
import Store from '../store/index.js'
export const payload = {
	slides: [
		{
			name: 'Imagine if Saint Lucia were hit by a Category 5 Hurricane',
			title: 'Imagine if Saint Lucia were hit by a Category 5 Hurricane',
			content:/* html */`
			<ul class="intro-list">
				<li>
					Packing 175 mile-per-hour (mph) winds (like Hurricane Maria)
				</li>
				<li>
					Dumping up to 12.7 inches of rainfall in 24hrs (like the 2013 Christmas Eve Trough) and
				</li>
				<li>
					Cutting WASCO water supply for two weeks!
				</li>
			</ul>`,
			image: char_4,
			imageStyles: `right`,
			duration: 8,
			weather: {
				icon: 'storms',
				position: 'right'
			}
		},
		{
			name: 'Are you ready?',
			title: 'Are you Ready? ',
			content:/* html */`
			<ul class="intro-list">
				<li>
				How would your home be impacted?
				</li>
				<li>
        What could you do today to reduce the expected impact to your home?
				</li>
			</ul>`,
			image: char_2,
			imageStyles: `right`,
			duration: 12,
			weather: {
				icon: 'light_storms',
				position: 'left'
			}
		},
		{
			name: '',
			/* title: 'Climate Change', */
			content:/* html */`

			<p>Climate change is causing more intense hurricanes, more frequent floods and more severe droughts in the Caribbean. </p>
			<p>But we can adapt to these hazards by making our homes more resilient to strong winds, floods and water shortages.</p>
		`,
			image: char_3,
			imageStyles: `-38px`,
			duration: 6,
			weather: {
				icon: 'sunny',
				position: 'right'
			}
		},
		{
			/* 		<ul class="row">
				<li class="col s4">
					Wind
				</li>
				<li class="col s4">
					Flood
				</li>
				<li class="col s4">
					Water Shortage
				</li>
			</ul> */
			name: '',
			title: 'Assess Your Home’s Resilience and Create an Adaptation Plan',
			content:/* html */`This App will guide you through a step-by-step home assessment and help you estimate the potential impact wind, flooding and water shortage from a Category 5 hurricane could have on your home.`,
			image: char_5,
			imageStyles: `-38px`,
			duration: 6,
			weather: {
				icon: 'sunny',
				position: 'left'
			}
		},

		{
			name:/* 'Enter to Win the SLDB Act to Adapt School Competition' */'',
			title: 'Enter the SLDB <em> Act to Adapt </em> Competition',
			content:/* html */`
			Once you complete the Climate Change Home Risk Assessment, enter the Saint Lucia Development Bank (SLDB) <em>Act to Adapt </em> Competition for a chance to win big to help implement your proposed adaptation and mitigation measures. The <em>Act to Adapt</em> Competition is powered by SLDB Climate Adaptation Financing Facility (CAFF).
		`,
			image: char_1,
			imageStyles: `-38px`,
			duration: 6,
			weather: {
				icon: 'sunny',
				position: 'right'
			},
			button: {
				type: 'button',
				action: async () => {
					Store.commit('Main/SET_FIRST_LOAD', false)
					Router.push({ path: '/' })
				},
				text: `Let's get started!`,
				tag: 'a', // a === <a></a> || button === <button></button>
				route: { path: '/' }, // if type is router-link
				class: 'btn amber grey-text text-darken-3 z-depth-0 btn-rounded'
			}
		},
	]
}

/* 			<div class="center" style="margin-top:24px;">
				<a href="/register" class="btn grey-text text-darken-3 waves-effect white btn-rounded">Let's Get Started</a>
			</div> */